import { VStack, Heading, Icon, Text, HStack, Button, Flex, StackDivider } from '@chakra-ui/react';
import { IoAdd, IoRemove, IoStopwatchOutline } from 'react-icons/io5';

export type MealBoxContainerProps = {
  isExpired: boolean;
  mealBoxType: string;
  time: string;
  amount: number;
  count: number;
  onUpdateCount: (count: number) => void;
};

// 歸還餐盒細項以及數量調整
export default function MealBoxContainer({
  isExpired,
  mealBoxType,
  time,
  amount,
  count,
  onUpdateCount,
}: MealBoxContainerProps) {
  const handlePlusAmount = () => {
    if (count < amount) {
      onUpdateCount(count + 1);
    }
  };
  const handleMinusAmount = () => {
    if (count > 0) {
      onUpdateCount(count - 1);
    }
  };
  return (
    <Flex direction="column" align="stretch">
      <HStack
        align="stretch"
        justify="space-between"
        bgColor="secondary"
        borderTopRadius="5px"
        py={2}
        px={3}
      >
        <Heading fontSize="sm" letterSpacing={2} color="white">
          {mealBoxType}
        </Heading>
      </HStack>
      <VStack
        p={2}
        align="stretch"
        borderBottomRadius="5px"
        borderTop="none"
        borderColor="gray.400"
        borderWidth="1px"
        divider={<StackDivider />}
        spacing={1}
      >
        <HStack spacing={1} align="center">
          <Icon as={IoStopwatchOutline} boxSize="1.125rem" />
          <Text fontWeight="bold" fontSize="xs" color={isExpired ? 'danger.600' : 'fontColor'}>
            歸還期限：{time}
          </Text>
        </HStack>
        <HStack py={2} justify="space-between">
          <Text fontSize="xs" color="gray.500">
            歸還數量
          </Text>
          <HStack>
            <Button
              p={1}
              size="sm"
              bgColor="gray.200"
              onClick={handleMinusAmount}
              _hover={{
                bgColor: 'gray.500',
              }}
              _focus={{
                outline: 'none',
                bgColor: 'gray.500',
              }}
              cursor={count === 0 ? 'unset' : 'pointer'}
              opacity={count === 0 ? 0.3 : 1}
            >
              <Icon boxSize="1.25rem" color="fontColor" as={IoRemove} />
            </Button>
            <Text minW="2rem" align="center" fontSize="lg" fontWeight="bold">
              {count}
            </Text>
            <Button
              p={1}
              size="sm"
              bgColor="gray.200"
              _hover={{
                bgColor: 'gray.500',
              }}
              _focus={{
                outline: 'none',
                bgColor: 'gray.500',
              }}
              onClick={handlePlusAmount}
              cursor={count === amount ? 'unset' : 'pointer'}
              opacity={count === amount ? 0.3 : 1}
            >
              <Icon boxSize="1.25rem" color="fontColor" as={IoAdd} />
            </Button>
          </HStack>
        </HStack>
      </VStack>
    </Flex>
  );
}
